import { render, staticRenderFns } from "./CGU.vue?vue&type=template&id=49093b71&"
import script from "./CGU.vue?vue&type=script&lang=js&"
export * from "./CGU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports